import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-image-skeleton',
  templateUrl: './image-skeleton.component.html',
  styleUrls: ['./image-skeleton.component.scss']
})
export class ImageSkeletonComponent {
  @Input() width: string = '100%';
  @Input() height: string = '150px';
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() isResponsive: boolean = false;
}